<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                <span class="title">{{ $t('title.smallAsset') }}</span>
                <div class="d-flex">

                    <v-btn size="small" variant="outlined" color="primary" class="mr-4 action-btn"
                        prepend-icon="mdi-circle" :disabled="isActiveStatus">
                        {{ $t('general.aktivna/neaktivna') }}
                    </v-btn>

                    <v-switch v-model="isActiveStatus" hide-details density="compact" class="mr-4"
                        style="margin-top:-7px" />

                    <v-btn size="small" variant="outlined" color="danger" class="action-btn" prepend-icon="mdi-circle"
                        :disabled="!isActiveStatus">
                        {{ $t('general.rashodovana') }}
                    </v-btn>

                    <div style="width: 100px;" />
                    <v-tooltip location="bottom" content-class="custom-tooltip">
                        <template #activator="{ props }">
                            <v-btn v-bind="props" size="small" variant="outlined" color="primary"
                                class="mr-2 action-btn" icon="mdi-eye" @click="printAssets" />
                        </template>
                        {{ $t('general.viewprint') }}
                    </v-tooltip>

                    <v-tooltip location="bottom" content-class="custom-tooltip">
                        <template #activator="{ props }">
                            <v-btn v-bind="props" size="small" variant="outlined" color="success"
                                class="mr-2 action-btn" @click="exportToExcel" icon="mdi-file-excel" />
                        </template>
                        {{ $t('general.exportExcel') }}
                    </v-tooltip>

                    <v-tooltip location="bottom" content-class="custom-tooltip">
                        <template #activator="{ props }">
                            <v-btn v-bind="props" size="small" variant="outlined" color="primary" class="action-btn"
                                icon="mdi-plus" @click="addAsset" />
                        </template>
                        {{ $t('general.addSmallAsset') }}
                    </v-tooltip>

                </div>
            </v-card-title>

            <v-card-text>
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" class="mb-2" density="compact"
                    autocomplete="off" />

                <!-- PRETRAGA PO PREDEFINISANIM VRIJEDNOSTIMA-->
                <v-row dense class="mb-4">

                    <!-- Datum od -->
                    <v-col cols="12" md="2">
                        <v-text-field v-model="dateFrom" :label="$t('general.datumOd')" type="date"
                            density="comfortable" hide-details="auto" clearable clear-icon="mdi-close"
                            class="my-text" />
                    </v-col>

                    <!-- Datum do -->
                    <v-col cols="12" md="2">
                        <v-text-field v-model="dateTo" :label="$t('general.datumDo')" type="date" density="comfortable"
                            hide-details="auto" clearable clear-icon="mdi-close" class="my-text" />
                    </v-col>

                    <!-- Korisnik -->
                    <v-col cols="12" md="3">
                        <v-select v-model="selectedUser" :items="users" item-title="Name" item-value="UserId"
                            :label="$t('general.zaduzenaOsoba')" clearable density="comfortable" hide-details="auto"
                            class="my-select" />
                    </v-col>

                    <!-- Lokacija -->
                    <v-col cols="12" md="2">
                        <v-select v-model="selectedLocation" :items="locations" item-title="Name" item-value="Id"
                            :label="$t('general.lokacija')" clearable density="comfortable" hide-details="auto"
                            class="my-select" />
                    </v-col>


                </v-row>
                <!-- KRAJ PRETRAGE PO PREDEFINISANIM VRIJEDNOSTIMA-->

                <v-data-table :headers="headers" :items="filteredAssets" :loading="loading"
                    :loading-text="$t('general.loading')" class="min-width-table custom-header" :items-per-page="15">

                    <!-- Bold naslovi i sort ikonice -->
                    <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
                        <tr>
                            <th v-for="column in columns" :key="column.value"
                                @click="() => column.sortable && toggleSort(column)" :style="{
                                    cursor: column.sortable ? 'pointer' : 'default',
                                    width: column.width,
                                    maxWidth: column.width,
                                    textAlign:
                                        column.value === 'actions'
                                            ? 'right'
                                            : column.value === 'StatusName'
                                                ? 'center'
                                                : 'left'
                                }" class="sortable-header">

                                <div class="d-flex align-center w-100" :class="column.value === 'actions'
                                    ? 'justify-end'
                                    : column.value === 'StatusName'
                                        ? 'justify-center'
                                        : 'justify-space-between'
                                    ">
                                    <strong>{{ column.text }}</strong>

                                    <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2"
                                        :class="{ active: isSorted(column) }">
                                        {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down' }}
                                    </v-icon>
                                </div>
                            </th>
                        </tr>
                    </template>


                    <!-- Redovi -->
                    <template v-slot:item="{ item }">
                        <tr :class="rowClass(item)">
                            <td>{{ item.Name }}</td>
                            <td :style="!item.UserId ? { color: 'red', fontWeight: '600' } : {}">
                                {{ item.UName || $t('general.nerasporedjeno') }}
                            </td>
                            <td>{{ item.LocationName }}</td>
                            <td style="text-align: right;">{{ formatMoney(item.Price) }}</td>
                            <td style="text-align: center;">{{ formatDate(item.Date) }}</td>
                            <td style="text-align: center;">
                                <div class="d-flex justify-center align-center">
                                    <v-menu location="bottom" offset="4">

                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" variant="text" class="status-btn">
                                                <img v-if="parseInt(item.StatusId) === 1" :src="statusImages.aktivan"
                                                    height="22" />
                                                <img v-if="parseInt(item.StatusId) === 2" :src="statusImages.neaktivan"
                                                    height="22" />
                                                <img v-if="parseInt(item.StatusId) === 3" :src="statusImages.rashodovan"
                                                    height="22" />
                                                <img v-if="parseInt(item.StatusId) === 4"
                                                    :src="statusImages.predlogRashoda" height="22" />
                                            </v-btn>
                                        </template>

                                        <v-list density="compact">
                                            <v-list-item
                                                v-for="s in statusOptions.filter(s => isStatusAllowed(item.StatusId, s.id))"
                                                :key="s.id" :disabled="s.id === item.StatusId"
                                                @click="s.id !== item.StatusId && askConfirmStatusChange(item, s.id)">
                                                <v-list-item-title class="d-flex align-center justify-space-between">
                                                    {{ s.name }}
                                                    <v-icon v-if="s.id === item.StatusId" size="14">mdi-check</v-icon>
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>

                                    </v-menu>
                                </div>
                            </td>

                            <!-- IKONICE-->
                            <td class="actions-cell">
                                <div class="actions-main">
                                    <!-- PREGLED -->
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="info"
                                                class="action-btn mr-2" @click="viewAsset(item)">
                                                <v-icon size="16">mdi-eye</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.pregled') }}
                                    </v-tooltip>

                                    <!-- UREDI -->
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="primary"
                                                class="action-btn mr-2" @click="editAsset(item)">
                                                <v-icon size="16">mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.uredi') }}
                                    </v-tooltip>

                                    <!-- POBRISI-->
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="red"
                                                class="action-btn mr-2" @click="openDeleteDialog(item)">
                                                <v-icon size="16">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.delete') }}
                                    </v-tooltip>

                                    <!-- ISTORIJA -->
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="small" variant="outlined" color="secondary"
                                                class="action-btn" @click="openHistory(item.Id)">
                                                <v-icon size="16">mdi-history</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.Istorija') }}
                                    </v-tooltip>
                                </div>
                            </td>
                            <!-- KRAJ IKONICA-->
                        </tr>
                    </template>

                </v-data-table>

            </v-card-text>
        </v-card>

        <!-- Dijalog za dodavanje/uređivanje sredstva -->
        <BaseModal v-model="dialog" size="xl" :title="viewMode
            ? this.$t('modalni.smallAsset.pregled')
            : editMode
                ? this.$t('modalni.smallAsset.uredi')
                : this.$t('modalni.smallAsset.dodaj')" :is-read-only="viewMode">
            <v-form ref="assetForm" v-model="isFormValid">

                <!-- ================ ROW 1 ================= -->
                <v-row dense>

                    <v-col cols="12" md="3">
                        <v-text-field v-model="form.SerialNumber" :label="$t('table.smallAssetFull.SerijskiBroj')"
                            :readonly="viewMode" class="my-text" autocomplete="off" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="form.ReverseNumber" :label="$t('table.smallAssetFull.BrojReversa')"
                            :readonly="viewMode" class="my-text" autocomplete="off" />
                    </v-col>
                </v-row>

                <!-- ================= ROW 2 ================= -->
                <v-row dense>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="form.AssetName" :label="$t('table.smallAssetFull.Naziv')"
                            :rules="[rules.required]" required :readonly="viewMode" class="my-text"
                            autocomplete="off" />
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-text-field v-model="form.Quantity" :label="$t('table.smallAssetFull.Kolicina')" type="number"
                            min="1" :rules="[rules.required]" required :readonly="viewMode" class="my-text"
                            autocomplete="off" />
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field v-model="form.PurchasePrice" :label="$t('table.smallAssetFull.NabavnaVr')" v-money
                            :rules="[rules.required]" required :readonly="viewMode" class="my-text"
                            autocomplete="off" />

                    </v-col>
                </v-row>


                <!-- ================= ROW 3  ================= -->
                <v-row dense>
                    <v-col cols="12" md="3">
                        <v-select v-model="form.assigned_to" :items="users" item-title="Name" item-value="UserId"
                            :label="$t('table.smallAssetFull.ZaduzenaOsoba')" :rules="[rules.required]" required
                            :readonly="viewMode" class="my-selectModal" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select v-model="form.location" :items="locations" item-title="Name" item-value="Id"
                            :label="$t('table.smallAssetFull.Lokacija')" :rules="[rules.required]" required
                            @update:model-value="onLocationChange" :readonly="viewMode" class="my-selectModal" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select v-model="form.room" :items="rooms" item-title="Name" item-value="Id"
                            :label="$t('table.smallAssetFull.Soba')" :disabled="!form.location" :readonly="viewMode"
                            clearable :rules="[rules.required]" required class="my-selectModal" />
                    </v-col>

                    <template v-if="editMode || viewMode">
                        <v-col cols="12" md="3">
                            <v-select v-model="form.StatusId"
                                :items="statusOptions.filter(s => isStatusAllowed(form.StatusId, s.id) || s.id === form.StatusId)"
                                item-title="name" item-value="id" :label="$t('table.smallAssetFull.Status')"
                                :rules="[rules.required]" required :readonly="viewMode" :disabled="form.StatusId === 3"
                                class="my-selectModal" />
                        </v-col>
                    </template>
                </v-row>

                <!-- ================= ROW 4  ================= -->
                <v-row dense>

                    <v-col cols="12" md="3">
                        <v-text-field v-model="form.PurchaseDate" :label="$t('table.smallAssetFull.DatumNabavke')"
                            type="date" :rules="[rules.required]" required :readonly="viewMode" clearable
                            clear-icon="mdi-close" class="my-text" autocomplete="off" />
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-text-field v-model="form.Supplier" :label="$t('table.smallAssetFull.Dobavljač')"
                            :readonly="viewMode" class="my-text" autocomplete="off" />
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-text-field v-model="form.PrNumber" :label="$t('table.smallAssetFull.BrojNabavke')"
                            :readonly="viewMode" class="my-text" autocomplete="off" />
                    </v-col>
                </v-row>

                <!-- ================= ROW 5 ================= -->
                <v-row dense>
                    <v-col cols="12" md="6">
                        <v-textarea v-model="form.AssetDescription" :label="$t('table.smallAssetFull.Opis')" rows="3"
                            auto-grow :readonly="viewMode" class="my-text" autocomplete="off" />
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-textarea v-model="form.Note" :label="$t('table.smallAssetFull.Napomena')" rows="3" auto-grow
                            :readonly="viewMode" class="my-text" autocomplete="off" />
                    </v-col>
                </v-row>
            </v-form>

            <template #footer>
                <div class="d-flex justify-end ga-2">

                    <!-- OTKAŽI -->
                    <v-btn variant="outlined" @click="closeDialog">
                        <span style="font-size:14px; font-weight: 600;">{{ $t('general.cancel') }}</span>
                    </v-btn>

                    <!-- SAČUVAJ -->
                    <v-btn v-if="!viewMode" color="primary" variant="flat" @click.prevent="saveAsset" :loading="saving"
                        :disabled="saving">
                        <span style="font-size:14px; font-weight: 600;">{{ $t('general.save') }}</span>
                    </v-btn>
                </div>
            </template>

        </BaseModal>

        <!-- ISTORIJA -->
        <BaseModal v-model="historyDialog" :title="this.$t('modalni.smallAsset.IstorijaStalnogSredstva')"
            :is-read-only="true" size="lg">
            <div class="mb-4" style="font-size: 14px;">
                <strong>{{ this.$t('modalni.asset.DatumNabavke') }} </strong>
                <span v-if="activationDateValue">
                    {{ formatDate(activationDateValue) }}
                </span>

                <span v-else>—</span>
            </div>

            <v-divider class="mb-1" />

            <v-list density="comfortable">
                <v-list-item v-for="h in assetHistory" :key="h.id">
                    <v-list-item-title style="font-size: 14px;">
                        <strong>{{ formatDate(h.date) }}</strong> – {{ h.text }}
                    </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="assetHistory.length === 0">
                    <v-list-item-title
                        style="font-size: 14px; text-transform: uppercase; text-align: center; font-weight: bold;">{{
                            $t('User_message.m122') }}</v-list-item-title>
                </v-list-item>
            </v-list>

            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn color="primary" variant="flat" @click="historyDialog = false">
                        <span style="font-size:14px; font-weight: 600;">{{ $t('general.close') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

        <!-- PROMJENA STATUSA -->
        <BaseModal v-model="confirmStatusDialog" :title="this.$t('modalni.smallAsset.promjenaStatusaModalni')">
            <p class="confirm-text" style="font-size: 14px;">
                {{ this.$t('modalni.smallAsset.promjenaStatusaPoruka1') }}<strong>{{
                    pendingStatusChange?.asset?.Name
                }}</strong>{{
                        this.$t('modalni.smallAsset.promjenaStatusaPoruka2') }}
                <strong>
                    {{statusOptions.find(s => s.id === pendingStatusChange?.newStatusId)?.name}}
                </strong>?
            </p>

            <!-- NAPOMENA -->
            <v-textarea v-model="statusChangeNote" :label="$t('table.smallAssetFull.Napomena')" rows="3" auto-grow
                class="my-text mt-3" autocomplete="off" />

            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="cancelStatusChange">
                        <span style="font-size:14px; font-weight: 600;">{{ this.$t('general.cancel') }}</span>
                    </v-btn>

                    <v-btn color="primary" @click="confirmStatusChange">
                        <span style="font-size:14px; font-weight: 600;">{{ this.$t('general.potvrdi') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>


        <!-- Dijalog za potvrdu brisanja sredstva -->
        <BaseModal v-model="deleteDialog" :title="this.$t('modalni.smallAsset.brisi')">
            <p>{{ this.$t('modalni.smallAsset.brisanjePoruka') }} <strong>{{ deleteAssetName }}</strong>?</p>

            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <!-- OTKAŽI -->
                    <v-btn variant="outlined" @click="deleteDialog = false">
                        <span style="font-size:14px; font-weight: 600;">{{ this.$t('general.cancel') }}</span>
                    </v-btn>

                    <!-- OBRIŠI -->
                    <v-btn color="danger" variant="flat" @click="confirmDelete">
                        <span style="font-size:14px; font-weight: 600; color: #FFF">{{
                            this.$t('general.deleteButton') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

        <!--Save/Print dialog-->
        <BaseModal v-model="reportPreview" size="xl" :title="$t('print.listaSitnogInventara')" height="90vh"
            modalClass="report-modal" :hideFooter="true">

            <template #header-actions>

                <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.download')">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" icon variant="plain" @click="downloadPDF">
                            <v-icon size="18"
                                style="padding-top: 2px !important; padding-left: 10px !important;">mdi-download</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>

                <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.print')">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" icon variant="plain" @click="printReport">
                            <v-icon size="18">mdi-printer</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>

            </template>

            <iframe ref="reportFrame" :style="{
                width: '100%',
                height: '100%',
                border: 'none',
                transform: `scale(${zoom})`,
                transformOrigin: 'top left'
            }" />

        </BaseModal>
    </v-container>
</template>

<script>
import BaseModal from "@/components/dialogs/BaseModal.vue";
import { format } from "date-fns";
import ExcelJS from "exceljs"
import { saveAs } from "file-saver";
import { printTable, fetchHeaderImage } from "@/services/printService";
import html2pdf from "html2pdf.js"

export default {
    name: "SmallAssetsPage",

    data() {
        return {
            saving: false,
            html: '',
            zoom: 1,
            reportPreview: false,
            selectedUser: null,
            selectedLocation: null,
            activationDateValue: null,
            confirmStatusDialog: false,
            pendingStatusChange: {
                asset: null,
                newStatusId: null,
                oldStatusId: null,
            },
            viewMode: false,
            isFormValid: false,
            deleteDialog: false,
            deleteAssetId: null,
            deleteAssetName: '',
            search: "",
            dateFrom: null,
            dateTo: null,
            assets: [],
            users: [],
            loading: false,
            dialog: false,
            editMode: false,
            selectedId: null,
            locations: [],
            rooms: [],
            statusChangeNote: '',

            rules: {
                required: v => (v !== null && v !== undefined && v !== '') || this.$t('systemMessage.m1'),
            },


            form: {
                ReverseNumber: "",      // Broj reversa
                AssetName: "",          // Sredstvo
                assigned_to: null,       // Zadužena osoba
                room: "",                // Soba
                location: "",            // Lokacija
                PurchasePrice: null,   // Nabavna vr.
                PurchaseDate: null,    // Datum nabavke
                AssetDescription: "",  // Opis sredstva
                Note: "",              // Napomena
                Supplier: "",            // Dobavljač
                PrNumber: "",           // Broj PR
                Quantity: 1,             // Kom.
                SerialNumber: "",       // S/N
                StatusId: null,         // Status
            },
            historyDialog: false,
            assetHistory: [],
            isActiveStatus: false
        };
    },

    computed: {
        imageLang() {
            const lang = localStorage.getItem('lang')
            if (lang === 'sr' || lang === 'cir-ekavica') return 'Cir'
            if (lang === 'en') return 'Eng'
            return 'Lat'
        },
        statusImages() {
            const lang = this.imageLang
            return {
                aktivan: `/img/aktivan${lang}.png`,
                neaktivan: `/img/neaktivan${lang}.png`,
                rashodovan: `/img/rashodovan${lang}.png`,
                predlogRashoda: `/img/predlogRashoda${lang}.png`,
            }
        },

        headers() {
            return [
                { text: this.$t('table.smallAsset.naziv'), value: "Name", sortable: true, width: 'calc(49% - 200px)' },
                { text: this.$t('table.smallAsset.zaduzenaOsoba'), value: "UName", sortable: true, width: "12%" }, // ← UserName → UName
                { text: this.$t('table.smallAsset.lokacija'), value: "LocationName", sortable: true, width: "10%" },
                { text: this.$t('table.smallAsset.NabavnaVr'), value: "Price", sortable: true, width: "9.5%" },
                { text: this.$t('table.smallAsset.DatumNabavke'), value: "Date", sortable: true, width: "9%" },
                { text: this.$t('table.smallAsset.status'), value: "StatusName", sortable: false, width: "130px" },
                { text: this.$t('general.optionsUPPER'), value: "actions", sortable: false, width: "200px" },
            ]
        },
        statusOptions() {
            return [
                { id: 1, name: this.$t('general.aktivan') },
                { id: 2, name: this.$t('general.neaktivan') },
                { id: 3, name: this.$t('general.rashodovan') },
                { id: 4, name: this.$t('general.predlogZaRashod') },
            ];
        },

        filteredAssets() {
            const term = (this.search || "").toLowerCase();
            const nerasporedjeno = this.$t('general.nerasporedjeno').toLowerCase()

            const filtered = this.assets.filter(asset => {
                const displayName = asset.UName
                    ? String(asset.UName).toLowerCase()
                    : nerasporedjeno

                const matchesSearch =
                    String(asset.InvNumber ?? "").toLowerCase().includes(term) ||
                    String(asset.Name ?? "").toLowerCase().includes(term) ||
                    displayName.includes(term) ||
                    String(asset.LocationName ?? "").toLowerCase().includes(term) ||
                    String(asset.StatusName ?? "").toLowerCase().includes(term) ||
                    String(asset.Price ?? "").toLowerCase().includes(term)

                let matchesDate = true;
                if (this.dateFrom)
                    matchesDate = matchesDate && asset.Date && new Date(asset.Date) >= new Date(this.dateFrom)
                if (this.dateTo)
                    matchesDate = matchesDate && asset.Date && new Date(asset.Date) <= new Date(this.dateTo)

                const matchesUser =
                    this.selectedUser === null ||
                    (this.selectedUser === 0
                        ? !asset.UserId
                        : Number(asset.UserId) === Number(this.selectedUser))

                const matchesLocation =
                    !this.selectedLocation ||
                    Number(asset.LocationId) === Number(this.selectedLocation)

                return matchesSearch && matchesDate && matchesUser && matchesLocation
            })
            return filtered
        },
    },
    watch: {
        isActiveStatus() {
            this.loadAssets()
        },
        'form.location'(newVal, oldVal) {
            if (this.editMode && newVal !== oldVal) {
                this.form.room = null

                this.$nextTick(() => {
                    this.$refs.assetForm?.validate()
                })
            }
        }
    },
    components: {
        BaseModal,
    },
    async mounted() {
        await Promise.all([
            this.fetchUsers(),
            this.fetchLocations(),
        ])
        await this.loadAssets()
    },
    methods: {
        isStatusAllowed(currentStatusId, newStatusId) {
            if (currentStatusId === 3) return false
            if ((currentStatusId === 1 || currentStatusId === 2) && newStatusId === 3) return false
            if (currentStatusId === 4) return true
            return true
        },
        async loadAssets() {

            if (this.isActiveStatus) {
                await this.scrappedAssets()
            } else {
                await this.fetchAssets()
            }

        },
        generateReportFileName(title) {

            const date = new Date()

            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()

            const compactDate = `${day}${month}${year}`

            const cleanTitle = title
                .replace(/[čć]/g, "c")
                .replace("ž", "z")
                .replace("š", "s")
                .replace("đ", "d")
                .split(" ")
                .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                .join("")

            return `${cleanTitle}_${compactDate}.pdf`
        },

        openReportPreview(html) {

            this.reportPreview = true

            this.$nextTick(() => {
                this.$nextTick(() => {

                    const iframe = this.$refs.reportFrame

                    if (!iframe) return

                    const doc = iframe.contentWindow.document

                    doc.open()
                    doc.write(html)
                    doc.close()

                })
            })
        },

        printReport() {
            const iframe = this.$refs.reportFrame
            iframe.contentWindow.print()
        },

        downloadPDF() {

            const container = document.createElement("div")
            container.innerHTML = this.html

            const title = container.querySelector("h2")?.innerText

            const fileName = this.generateReportFileName(title)

            html2pdf()
                .set({
                    margin: 10,
                    filename: fileName,
                    html2canvas: { scale: 2 },
                    jsPDF: {
                        unit: "mm",
                        format: "a4",
                        orientation: "landscape"
                    }
                })
                .from(container)
                .save()
        },

        parseMoney(value) {
            if (value === null || value === undefined || value === '') return null

            if (typeof value === 'number') return value

            return Number(
                value
                    .replace(/\./g, '')
                    .replace(',', '.')
            )
        },
        async scrappedAssets() {
            this.loading = true
            try {
                var data = {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                }
                const r = await this.$axios.post('SmallAsset/SitnaSredstva_Rashodovana/', data)
                this.assets = r.data || []
            } catch (err) {
                console.error(err)
                this.assets = []
            } finally {
                this.loading = false
            }
        },
        formatMoney(value) {
            if (value === null || value === undefined || value === '') return '-'

            const number = Number(value)
            if (Number.isNaN(number)) return '-'

            return (
                number.toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
            )
        },
        async printAssets() {
            const assets = this.filteredAssets || []

            if (!assets.length) {
                this.$store.dispatch("NOTIF_WARNING", {
                    poruka: this.$t("print.na"),
                    position: "center",
                    icon: "error",
                    timer: 4500,
                    width: "550",
                })
                return
            }

            const headerImg = await fetchHeaderImage(this.$axios)
            this.html = printTable({
                title: this.$t("print.listaSitnogInventara"),
                columns: [
                    { key: "name", label: this.$t("table.smallAsset.naziv"), width: "30%" },
                    { key: "user", label: this.$t("table.smallAsset.zaduzenaOsoba"), width: "20%" },
                    { key: "location", label: this.$t("table.smallAssetFull.Lokacija"), width: "15%" },
                    { key: "price", label: this.$t("table.smallAsset.NabavnaVr"), width: "11%", align: "right" },
                    { key: "date", label: this.$t("table.smallAsset.DatumNabavke"), width: "15%", align: "center" },
                    { key: "status", label: this.$t("table.smallAsset.status"), width: "9%", align: "center" },
                ],
                data: assets.map(a => ({
                    name: a.Name ?? "-",
                    user: a.UName ?? this.$t("general.nerasporedjeno"),
                    location: a.LocationName ?? "-",
                    price: this.formatMoney(a.Price),
                    date: this.formatDate(a.Date),
                    status: a.StatusName ?? "-",
                })),
                headerImg,
                footer: `${this.$t("exportToExcel.pokrenuo")} ${localStorage.getItem("Name")} <br />
                            ${this.$t("print.m1")} ${format(new Date(), "dd.MM.yyyy.")}`,
            })
            this.openReportPreview(this.html)
        },

        mapHistory(raw) {
            if (!Array.isArray(raw) || raw.length === 0) return []

            const history = []
            const v = (x) => (x === null || x === undefined || x === "" ? "—" : x)

            history.push({
                id: `${raw[0].Id}-initial`,
                date: raw[0].Date,
                StatusId: raw[0].StatusId,
                text: `${this.$t('modalni.smallAsset.pocetnoStanje')}: ${v(raw[0].Name)} | ${v(raw[0].LocationName)}`
            })


            for (let i = 1; i < raw.length; i++) {
                // PROMJENA ZADUŽENJA
                if (raw[i - 1].UserId !== raw[i].UserId) {
                    history.push({
                        id: `${raw[i].Id}-user`,
                        date: raw[i].Date,
                        StatusId: raw[i].StatusId,
                        text: `${this.$t('modalni.smallAsset.promjenaZaduzenja')} ${v(raw[i - 1].Name)} → ${v(raw[i].Name)}`
                    })
                }

                // PROMJENA LOKACIJE
                if (raw[i - 1].LocationId !== raw[i].LocationId) {
                    history.push({
                        id: `${raw[i].Id}-location`,
                        date: raw[i].Date,
                        StatusId: raw[i].StatusId,
                        text: `${this.$t('modalni.smallAsset.promjenaLokacije')} ${v(raw[i - 1].LocationName)} → ${v(raw[i].LocationName)}`
                    })
                }

                // PROMJENA SOBE
                if (raw[i - 1].RoomId !== raw[i].RoomId) {
                    history.push({
                        id: `${raw[i].Id}-room`,
                        date: raw[i].Date,
                        StatusId: raw[i].StatusId,
                        text: `${this.$t('modalni.smallAsset.premjestaj')} ${v(raw[i - 1].RoomName)} → ${v(raw[i].RoomName)}`
                    })
                }

                // PROMJENA STATUSA (samo ako oba statusa postoje)
                if (
                    raw[i - 1].StatusId !== raw[i].StatusId &&
                    raw[i - 1].StatusId != null &&
                    raw[i].StatusId != null
                ) {
                    const statusMap = {
                        1: this.$t('general.aktivan'),
                        2: this.$t('general.neaktivan'),
                        3: this.$t('general.rashodovan')
                    }

                    history.push({
                        id: `${raw[i].Id}-status`,
                        date: raw[i].Date,
                        StatusId: raw[i].StatusId,
                        text: `${this.$t('modalni.smallAsset.promjenaStatusa1')} ${statusMap[raw[i - 1].StatusId]} → ${statusMap[raw[i].StatusId]}`
                    })
                }

                // PROMJENA NOTE-a
                if (raw[i - 1].Note !== raw[i].Note) {
                    history.push({
                        id: `${raw[i].Id}-note`,
                        date: raw[i].Date,
                        StatusId: raw[i].StatusId,
                        text: `${this.$t('modalni.asset.napomena')}: ${raw[i].Note ?? '—'}`
                    })
                }

                // PROMJENA REVERS BROJA
                if (raw[i - 1].ReverseNumber !== raw[i].ReverseNumber) {
                    history.push({
                        id: `${raw[i].Id}-reverse`,
                        date: raw[i].Date,
                        StatusId: raw[i].StatusId,
                        text: `${this.$t('modalni.smallAsset.promjenaReversBroja')} ${v(raw[i - 1].ReverseNumber)} → ${v(raw[i].ReverseNumber)}`
                    })
                }
            }

            return history
        },
        formatHistoryDate(dateStr) {
            if (!dateStr) return ''
            try {
                return format(new Date(String(dateStr).replace(" ", "T")), 'dd.MM.yyyy.')
            } catch {
                return dateStr
            }
        },
        //otvaranje prozora za promjenu statusa stalnog sredstva
        askConfirmStatusChange(item, newStatusId) {
            if (item.StatusId === newStatusId) return

            this.pendingStatusChange = {
                asset: item,
                oldStatusId: item.StatusId,
                newStatusId
            }

            this.confirmStatusDialog = true
        },
        //promjena statusa stalnog sredsta nakon potvrde
        async confirmStatusChange() {
            const { asset, newStatusId, oldStatusId } = this.pendingStatusChange
            if (!asset) return

            asset.StatusId = newStatusId

            try {
                await this.updateAssetStatus(asset.Id, newStatusId, asset.UserId, this.statusChangeNote)

                asset.StatusName =
                    this.statusOptions.find(s => s.id === newStatusId)?.name || ''

                this.confirmStatusDialog = false
                this.statusChangeNote = ''
                this.pendingStatusChange = {
                    asset: null,
                    newStatusId: null,
                    oldStatusId: null
                }
            } catch {
                asset.StatusId = oldStatusId
                asset.StatusName =
                    this.statusOptions.find(s => s.id === oldStatusId)?.name || ''
                this.confirmStatusDialog = false
                this.statusChangeNote = ''
                this.pendingStatusChange = {
                    asset: null,
                    newStatusId: null,
                    oldStatusId: null
                }
            }
        },
        cancelStatusChange() {
            this.confirmStatusDialog = false
            this.statusChangeNote = ''
            this.pendingStatusChange = {
                asset: null,
                newStatusId: null,
                oldStatusId: null
            }
        },
        rowClass(item) {
            if (item.StatusId === 3) return 'row-rashodovano'
            if (item.StatusId === 4) return 'row-predlog'
            if (item.StatusId === 2) return 'row-neaktivno'
            if (this.isOlderThan7Years(item.Date)) return 'row-old'
            if (!item.UserId) return 'row-unassigned'
            return ''
        },
        //update statusa stalnog sredstva
        async updateAssetStatus(assetId, statusId, userId, note = '') {
            try {
                await this.$axios.put(
                    'SmallAsset/SitnaSredstva/EditStatus',
                    {
                        AssetId: Number(assetId),
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                        StatusId: Number(statusId),
                        UserId: userId === 0 ? null : Number(userId),
                        Note: note
                    }
                )

                this.$store.dispatch("NOTIF_SUCCESS", {
                    poruka: this.$t('User_message.m99'),
                    position: "top-end",
                    timer: 2500,
                    action: "noreload"
                })

                await this.loadAssets()
            } catch (err) {
                this.$store.dispatch("NOTIF_WARNING", {
                    poruka: this.$t('User_message.m52'),
                    position: "center",
                    icon: "error",
                    timer: 4500,
                    width: "550"
                })
            }
        },

        async viewAsset(asset) {
            this.viewMode = true
            this.editMode = false
            this.selectedId = asset.Id

            this.form = {
                ReverseNumber: asset.ReverseNumber,
                AssetName: asset.Name,
                assigned_to: asset.UserId ? Number(asset.UserId) : null,
                room: null,
                location: asset.LocationId,
                PurchasePrice: asset.Price ?? null,
                PurchaseDate: asset.Date,
                AssetDescription: asset.Description,
                Note: asset.Note,
                Supplier: asset.Supplier,
                PrNumber: asset.PrNumber,
                Quantity: asset.Quantity,
                SerialNumber: asset.SerialNumber,
                StatusId: asset.StatusId,
            }

            await this.onLocationChange(asset.LocationId)
            this.form.room = asset.RoomId
            this.dialog = true
        },
        async onLocationChange(locationId) {
            this.form.room = null
            this.rooms = []
            if (!locationId) return
            try {
                const r = await this.$axios.post('Location/Rooms', {
                    LocationId: Number(locationId),
                    CompanyId: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.rooms = r.data || []
            } catch (err) {
                console.error(err)
                this.rooms = []
            }
        },
        openDeleteDialog(asset) {
            this.deleteAssetId = asset.Id
            this.deleteAssetName = asset.Name
            this.deleteDialog = true
        },
        async confirmDelete() {
            if (!this.deleteAssetId) return

            try {
                const r = await this.$axios.put(
                    'SmallAsset/SitnaSredstva/Delete/' + this.deleteAssetId
                )

                if (r.status === 200) {
                    this.$store.dispatch("NOTIF_SUCCESS", {
                        poruka: this.$t('User_message.m104'),
                        position: "top-end",
                        timer: 2500,
                        action: "noreload"

                    })

                    await this.loadAssets()
                }
            } catch (err) {
                this.$store.dispatch("NOTIF_WARNING", {
                    poruka: this.$t('User_message.m105'),
                    position: "center",
                    icon: "error",
                    timer: 4500,
                    width: "550"
                })
            } finally {
                this.deleteDialog = false
                this.deleteAssetId = null
                this.deleteAssetName = ''
            }
        },

        async fetchUsers() {
            try {
                const data = {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                }
                const res = await this.$axios.post("User/Show", data)
                this.users = [
                    { UserId: 0, Name: this.$t('table.asset.nerasporedjeno') },
                    ...(res.data || [])
                ]
            } catch (err) {
                console.error(err)
                this.users = []
            }
        },
        async fetchLocations() {
            try {
                const data = {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                }
                const res = await this.$axios.post("Location/Locations", data)
                this.locations = res.data || []
            } catch (err) {
                console.error(err)
                this.locations = []
            }
        },
        async fetchAssets() {
            this.loading = true
            try {
                var data = {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                }
                const res = await this.$axios.post('SmallAsset/SitnaSredstva/', data)
                this.assets = res.data || []
            } catch (err) {
                console.error(err)
                this.assets = []
            } finally {
                this.loading = false
            }
        },

        isOlderThan7Years(dateStr) {
            if (!dateStr) return false;
            const purchase = new Date(dateStr);
            const now = new Date();
            return (now - purchase) / (1000 * 60 * 60 * 24 * 365.25) > 7;
        },
        addAsset() {
            this.viewMode = false
            this.editMode = false
            this.selectedId = null
            this.resetForm()
            this.form.StatusId = 1
            this.dialog = true;

            this.$nextTick(() => {
                this.$refs.assetForm?.resetValidation()
            })
        },

        async editAsset(asset) {
            this.viewMode = false
            this.editMode = true
            this.selectedId = asset.Id

            this.form = {
                ReverseNumber: asset.ReverseNumber,
                AssetName: asset.Name,
                assigned_to: asset.UserId ? Number(asset.UserId) : null,
                room: null,
                location: asset.LocationId,
                PurchasePrice: asset.Price ?? null,
                PurchaseDate: asset.Date,
                AssetDescription: asset.Description,
                Note: asset.Note,
                Supplier: asset.Supplier,
                PrNumber: asset.PrNumber,
                Quantity: asset.Quantity,
                SerialNumber: asset.SerialNumber,
                StatusId: asset.StatusId,
            }

            await this.onLocationChange(asset.LocationId)
            this.form.room = asset.RoomId
            this.dialog = true

            this.$nextTick(() => {
                this.$refs.assetForm?.resetValidation()
            })
        },

        async saveAsset() {
            if (this.saving) return
            this.saving = true

            try {
                if (this.editMode && this.form.StatusId === 3) {
                    this.$store.dispatch("NOTIF_WARNING", {
                        poruka: this.$t('User_message.m123'),
                        position: "center",
                        icon: "error",
                        timer: 4500,
                        width: "550"
                    })
                    return
                }

                const { valid } = await this.$refs.assetForm.validate()
                if (!valid) return

                const payload = {
                    CompanyId: Number(localStorage.getItem("CompanyId")),
                    ReverseNumber: this.form.ReverseNumber,
                    Name: this.form.AssetName,
                    UserId: this.form.assigned_to === 0 ? null : this.form.assigned_to,
                    LocationId: this.form.location,
                    RoomId: this.form.room,
                    Price: this.parseMoney(this.form.PurchasePrice),
                    Date: this.form.PurchaseDate ? `${this.form.PurchaseDate}T00:00:00Z` : null,
                    Description: this.form.AssetDescription,
                    Supplier: this.form.Supplier,
                    PrNumber: this.form.PrNumber,
                    Quantity: Number(this.form.Quantity),
                    SerialNumber: this.form.SerialNumber,
                    Note: this.form.Note,
                    StatusId: this.form.StatusId,
                }

                if (this.editMode) {
                    await this.$axios.put('SmallAsset/SitnaSredstva/Edit', { ...payload, Id: this.selectedId })
                } else {
                    await this.$axios.post('SmallAsset/SitnaSredstva/Add', payload)
                }

                this.$store.dispatch("NOTIF_SUCCESS", {
                    poruka: this.editMode ? this.$t('User_message.m102') : this.$t('User_message.m100'),
                    position: "top-end",
                    timer: 2500,
                    action: "noreload"
                })

                this.dialog = false
                await this.loadAssets()

            } catch (err) {
                console.error(err)
                this.$store.dispatch("NOTIF_WARNING", {
                    poruka: this.$t('User_message.m103'),
                    position: "center",
                    icon: "error",
                    timer: 4500,
                    width: "550"
                })
            } finally {
                this.saving = false
            }
        },

        closeDialog() {
            this.dialog = false;
            this.viewMode = false;
            this.editMode = false;
            this.selectedId = null;
            this.resetForm();

            this.$nextTick(() => {
                this.$refs.assetForm?.resetValidation()
            })
        },

        resetForm() {
            this.form = {
                ReverseNumber: "",
                AssetName: "",
                assigned_to: null,
                location: null,
                room: null,
                PurchasePrice: null,
                PurchaseDate: null,
                AssetDescription: "",
                Note: "",
                Supplier: "",
                PrNumber: "",
                Quantity: 1,
                SerialNumber: "",
                StatusId: null,
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return "";
            try {
                return format(new Date(dateStr), "dd.MM.yyyy");
            } catch {
                return dateStr;
            }
        },

        async exportToExcel() {
            const assets = this.filteredAssets || []

            if (!assets.length) {
                this.$store.dispatch("NOTIF_WARNING", {
                    poruka: this.$t('exportToExcel.noData'),
                    position: "center",
                    icon: "error",
                    timer: 4500,
                    width: "550"
                })
                return
            }

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet(this.$t('exportToExcel.sitniInventar'))

            /* ================= NASLOV ================= */
            worksheet.mergeCells("A3:M3")
            worksheet.getCell("A3").value = this.$t('exportToExcel.pregledSitnogInventara')
            worksheet.getCell("A3").font = { size: 14, bold: true }
            worksheet.getCell("A3").alignment = { horizontal: "center" }

            /* ================= HEADER (RED 6) ================= */
            worksheet.getRow(6).values = [
                this.$t('exportToExcel.brojReversa'),
                this.$t('exportToExcel.sitniInventar'),
                this.$t('exportToExcel.zaduzenaOsoba'),
                this.$t('exportToExcel.soba'),
                this.$t('exportToExcel.lokacija'),
                this.$t('exportToExcel.nabavnaVr'),
                this.$t('exportToExcel.datumNabavke'),
                this.$t('exportToExcel.dobavljac'),
                this.$t('exportToExcel.brojPR'),
                this.$t('exportToExcel.kom'),
                this.$t('exportToExcel.serijskiBroj'),
                this.$t('exportToExcel.status'),
            ]
            worksheet.getRow(6).font = { bold: true }

            /* ================= ŠIRINE KOLONA ================= */
            worksheet.columns = [
                { width: 15 }, // Broj reversa
                { width: 40 }, // Sredstvo
                { width: 20 }, // Zadužena osoba
                { width: 10 }, // Soba
                { width: 20 }, // Lokacija
                { width: 15 }, // Nabavna vr.
                { width: 15 }, // Datum
                { width: 20 }, // Dobavljač
                { width: 15 }, // Broj PR
                { width: 5 },  // Kom.
                { width: 18 }, // S/N
                { width: 10 }, // Status
            ]
            worksheet.getColumn(6).numFmt = '#,##0.00'
            // Datum nabavke (kolona 8 = H)
            worksheet.getColumn(7).alignment = { horizontal: "center" }

            /* ================= PODACI (OD REDA 7) ================= */
            let rowIndex = 7

            assets.forEach(asset => {
                worksheet.getRow(rowIndex).values = [
                    asset.ReverseNumber || "",
                    asset.Name,
                    asset.UName || this.$t('asset.nerasporedjeno'),
                    asset.RoomName || "",
                    asset.LocationName || "",
                    Number(asset.Price ?? 0),
                    this.formatDate(asset.Date),
                    asset.Supplier || "",
                    asset.PrNumber || "",
                    asset.Quantity ?? 1,
                    asset.SerialNumber || "",
                    asset.StatusName || "",
                ]
                rowIndex++
            })

            /* ================= ZAMRZNI HEADER ================= */
            worksheet.views = [{ state: "frozen", ySplit: 6 }]

            /* ================= FOOTER ================= */
            worksheet.addRow([])
            worksheet.addRow([
                `${this.$t('exportToExcel.pokrenuo')} ${localStorage.getItem("Name")}`
            ])
            worksheet.addRow([
                `${this.$t('exportToExcel.datumKreiranja')} ${format(new Date(), "dd.MM.yyyy.")}`
            ])

            /* ================= SAVE ================= */
            const buffer = await workbook.xlsx.writeBuffer()

            saveAs(
                new Blob(
                    [buffer],
                    { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
                ),
                `${this.$t('exportToExcel.sitniInventar')}.xlsx`
            )
        },

        async openHistory(assetId) {
            this.historyDialog = true
            this.activationDateValue = null
            this.assetHistory = []

            try {
                const res = await this.$axios.post(
                    'SmallAsset/SitnaSredstva_Istorijat',
                    {
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                        AssetId: assetId,
                        LanguageId: Number(localStorage.getItem('LanguageId'))
                    }
                )

                const raw = Array.isArray(res.data) ? res.data : []

                this.assetHistory = this.mapHistory(raw)

                const activated = raw.find((h, index, arr) => {
                    if (h.StatusId !== 1) return false
                    const prev = arr[index - 1]
                    return !prev || prev.StatusId !== 1
                })

                this.activationDateValue =
                    activated?.Date ??
                    raw[0]?.Date ??
                    this.assets.find(a => a.Id === assetId)?.Date ??
                    null

            } catch (err) {
                console.error(this.$t('User_message.m113'), err)
                this.assetHistory = []
                this.activationDateValue = null
            }
        },
    },
};
</script>
